'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);

var handleCallback = function (entries, callback, setIsLoading) { return tslib_es6.__awaiter(void 0, void 0, void 0, function () {
    var _a, target;
    return tslib_es6.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = tslib_es6.__read(entries, 1), target = _a[0];
                if (!target.isIntersecting) return [3 /*break*/, 4];
                _b.label = 1;
            case 1:
                _b.trys.push([1, , 3, 4]);
                setIsLoading(true);
                return [4 /*yield*/, callback()];
            case 2:
                _b.sent();
                return [3 /*break*/, 4];
            case 3:
                setIsLoading(false);
                return [7 /*endfinally*/];
            case 4: return [2 /*return*/];
        }
    });
}); };
var useInfiniteScroll = function (_a) {
    var hasMore = _a.hasMore, rootRef = _a.rootRef, callback = _a.callback;
    var loaderRef = React.useRef(null);
    var _b = tslib_es6.__read(React.useState(false), 2), isLoading = _b[0], setIsLoading = _b[1];
    // Setting this to a ref because we want callback to change, but not be required in any dependencies
    var scrollMethod = React.useRef(callback);
    React.useEffect(function () {
        scrollMethod.current = callback;
    }, [callback]);
    React.useLayoutEffect(function () {
        if (!hasMore) {
            return function () { return null; };
        }
        var listener = function (entries) { return tslib_es6.__awaiter(void 0, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                handleCallback(entries, scrollMethod.current, setIsLoading);
                return [2 /*return*/];
            });
        }); };
        var option = {
            root: (rootRef === null || rootRef === void 0 ? void 0 : rootRef.current) || null,
            threshold: 0.1,
        };
        var observer = new IntersectionObserver(listener, option);
        if (loaderRef.current) {
            observer.observe(loaderRef.current);
        }
        return function () {
            observer.disconnect();
        };
    }, [hasMore, rootRef]);
    return {
        isLoading: isLoading,
        loaderRef: loaderRef,
    };
};

exports.handleCallback = handleCallback;
exports.useInfiniteScroll = useInfiniteScroll;
